export default __webpack_public_path__ + "static/media/roles-permission-white.033b4310.svg";